import { isDeclarationDisabled } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/utils/isDeclarationDisabled';
import { isKycDisabled } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/utils/isKycDisabled';
import { getUiApprovalState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/utils/getUiApprovalState';
import { getUiRejectionState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/utils/getUiRejectionState';
import { getDeclarationsApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/utils/getDeclarationsApprovalStatus';
import {
	KycApprovalStatus,
	Step,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { DataKYCFileTctWithFile, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';
import { ButtonVariant } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/KycActionButton.types';

export const getApprovalStatus = (
	isDeclarationsStep: boolean,
	currentInvestor: GetKYCInvestorInstanceRes | undefined,
	status: KycApprovalStatus | undefined
) => {
	return isDeclarationsStep ? getDeclarationsApprovalStatus(currentInvestor) : status;
};

export const getButtonStatus = (
	approvalStatus: NonNullable<KycApprovalStatus> | undefined,
	variant: ButtonVariant
) => {
	const buttonState: Record<ButtonVariant, KycApprovalStatus | 'ACCEPT' | 'REJECT'> = {
		approve: getUiApprovalState(approvalStatus),
		decline: getUiRejectionState(approvalStatus),
	};
	const status = buttonState[variant];
	return status as NonNullable<KycApprovalStatus> | 'REJECT' | 'ACCEPT';
};

export const isButtonDisabled = (
	isDeclarationsStep: boolean,
	currentStep: Step,
	currentInvestor: GetKYCInvestorInstanceRes | undefined,
	selectedKycFile: DataKYCFileTctWithFile | undefined,
	variant: ButtonVariant
) => {
	return isDeclarationsStep
		? isDeclarationDisabled({
				currentStep,
				currentInvestor,
				variant,
			})
		: isKycDisabled({ selectedKycFile, variant });
};
